import merge from 'lodash/merge';
import { Dimensions, StyleSheet } from 'react-native';
import { floatingActionButtonConfig, tokens, WHITE } from '../../constants';
import { checkIsPlatform, getCurrentEventControlState } from '../../utils';
export var getButtonIconStyle = props => {
  var iconOnly = props.iconOnly;
  if (!iconOnly) {
    return {
      marginRight: tokens.spacing.SPACING_8
    };
  }
};
export var getFloatingActionButtonStyles = (pressableState, props, width) => {
  var _a, _b, _c;
  var _ref = props || {},
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'sm' : _ref$size,
    config = _ref.config,
    _ref$iconOnly = _ref.iconOnly,
    iconOnly = _ref$iconOnly === void 0 ? false : _ref$iconOnly,
    _ref$position = _ref.position,
    position = _ref$position === void 0 ? 'bottom-center' : _ref$position,
    _ref$rightOffset = _ref.rightOffset,
    rightOffset = _ref$rightOffset === void 0 ? 0 : _ref$rightOffset,
    _ref$bottomOffset = _ref.bottomOffset,
    bottomOffset = _ref$bottomOffset === void 0 ? 0 : _ref$bottomOffset,
    controlState = _ref.controlState;
  var BUTTON_OFFSET = 16;
  var _controlState = getCurrentEventControlState(pressableState, controlState);
  var buttonControlState = (_a = props === null || props === void 0 ? void 0 : props.config.controlState) === null || _a === void 0 ? void 0 : _a[_controlState];
  var buttonColor = buttonControlState === null || buttonControlState === void 0 ? void 0 : buttonControlState.buttonColor;
  var height = (_c = (_b = config === null || config === void 0 ? void 0 : config.size) === null || _b === void 0 ? void 0 : _b[size]) === null || _c === void 0 ? void 0 : _c.height;
  var spacing = tokens.spacing;
  var paddingHorizontal = iconOnly ? spacing.SPACING_12 : spacing.SPACING_20;
  var windowWidth = Dimensions.get('window').width;
  var leftSpaceForCenter = windowWidth / 2 - width / 2;
  var positionStyle = {
    'bottom-center': {
      bottom: BUTTON_OFFSET + bottomOffset,
      left: leftSpaceForCenter
    },
    'bottom-right': {
      bottom: BUTTON_OFFSET + bottomOffset,
      right: BUTTON_OFFSET + rightOffset
    }
  };
  return StyleSheet.create({
    container: Object.assign(Object.assign(Object.assign({
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'row',
      flexGrow: 0,
      paddingHorizontal,
      paddingVertical: tokens.spacing.SPACING_12,
      backgroundColor: buttonColor,
      borderRadius: 100,
      borderWidth: 1,
      borderColor: WHITE
    }, iconOnly && {
      width: height
    }), {
      height,
      position: checkIsPlatform('web') ? 'fixed' : 'absolute',
      alignSelf: position == 'bottom-center' ? 'center' : 'flex-end'
    }), positionStyle === null || positionStyle === void 0 ? void 0 : positionStyle[position])
  });
};
export var getFloatingActionButtonProps = (props, context) => {
  var _a;
  var theme = (props === null || props === void 0 ? void 0 : props.theme) || (context === null || context === void 0 ? void 0 : context.theme);
  var configProps = merge(floatingActionButtonConfig === null || floatingActionButtonConfig === void 0 ? void 0 : floatingActionButtonConfig[theme], (_a = context === null || context === void 0 ? void 0 : context.floatingActionButton) === null || _a === void 0 ? void 0 : _a[theme]);
  return Object.assign(Object.assign({
    theme
  }, configProps), props);
};